import { ListItem, ListItemIcon, ListItemText, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { type Theme } from "@mui/material/styles";
import { useMemo } from "react";

import { useAuctionTimer } from "./Bids/AuctionBidCountdownTimer";
import { SHIFT_AUCTION_LABEL } from "./constants";
import { formatCountdownTime } from "./utils";

interface ShiftAuctionInfoListItemProps {
  auctionEndTime?: Date;
}

export function ShiftAuctionInfoListItem(props: ShiftAuctionInfoListItemProps) {
  const { auctionEndTime } = props;

  const { secondsLeft } = useAuctionTimer(auctionEndTime ?? new Date());

  const countdownDisplay = useMemo(() => formatCountdownTime(secondsLeft), [secondsLeft]);

  return (
    <ListItem>
      <ListItemIcon
        iconType="bolt-filled"
        color={(theme) => theme.palette.shift?.urgent.icon ?? ""}
      />
      <ListItemText
        primary={
          <Text semibold variant="h4" color={(theme) => theme.palette.shift?.urgent.text}>
            {SHIFT_AUCTION_LABEL}
          </Text>
        }
        secondary={
          <Stack spacing={4} sx={{ marginTop: 2 }}>
            <Text variant="body1">
              {SHIFT_AUCTION_LABEL} Shifts run for 5 minutes. You can choose the rate you&apos;d
              like as a bid, and the lowest bid wins!
            </Text>
            <Text variant="body1">
              Bids are private. If you win, you&apos;ll always earn at least what you bid.{" "}
              {SHIFT_AUCTION_LABEL} Shifts cannot be cancelled once booked.
            </Text>
            {auctionEndTime && (
              <Text variant="body1">
                {secondsLeft <= 0 ? (
                  "This auction has ended"
                ) : (
                  <>
                    This auction ends in{" "}
                    <Box
                      component="span"
                      sx={{ color: (theme: Theme) => theme.palette.shift?.urgent.text }}
                    >
                      {countdownDisplay}
                    </Box>
                  </>
                )}
                .
              </Text>
            )}
          </Stack>
        }
      />
    </ListItem>
  );
}
